import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="relative grain bg-[#1A1A1A] text-[#F9F8F6] mt-24">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight leading-none">Anhad<br />Collections</h2>
          <p className="font-sans text-sm text-[#c9c4bb] mt-6 max-w-sm leading-relaxed">
            Traditional Indian suits & kurtis, made with intention. Handpicked fabrics, honest craft, delivered across India.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8C7a7a] mb-5">Explore</p>
          <ul className="space-y-3 font-sans text-sm">
            <li><Link to="/shop" className="hover:text-[#c98a8a] transition-colors">All Products</Link></li>
            <li><Link to="/shop?category=Kurti" className="hover:text-[#c98a8a] transition-colors">Kurtis</Link></li>
            <li><Link to="/shop?category=Suit" className="hover:text-[#c98a8a] transition-colors">Suits</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8C7a7a] mb-5">Care</p>
          <ul className="space-y-3 font-sans text-sm">
            <li><Link to="/refund-policy" className="hover:text-[#c98a8a] transition-colors">15-Day Refunds</Link></li>
            <li><Link to="/customer-service" className="hover:text-[#c98a8a] transition-colors">Customer Service</Link></li>
            <li><a href="tel:+918168645249" className="hover:text-[#c98a8a] transition-colors">+91 81686 45249</a></li>
            <li><a href="mailto:anhadcollection.care@gmail.com" className="hover:text-[#c98a8a] transition-colors">anhadcollection.care@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#333] mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8C7a7a]">© {new Date().getFullYear()} Anhad Collections</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8C7a7a]">Crafted in India</p>
      </div>
    </div>
  </footer>
);

export default Footer;
